import register from '@kpsys/angularjs-register';
import GoToResponseController from './controllers/go-to-response.controller';
import ModalLoanRequestFormController from './controllers/modal-loan-request-form.controller';
import ModalLoginController from './controllers/modal-login.controller';
import ModalConversationService from './modal-conversation.service';
import SearchSelectionModalComponent from './search-selection-modal/search-selection-modal.component';
import RecordEditationModalComponent from './record-editation-modal/record-editation-modal.component';
import RegistrationOptionsModalComponent from './registration-options-modal/registration-options-modal.component';
import RedirectionResponseController from './controllers/redirection-response.controller';
import DepartmentCreatedDialogController from './controllers/department-created-dialog.controller';
import UniversalFormController from './controllers/universal-form.controller';
import PrintPageController from './controllers/print-page.controller';
import UserActivationRequiredDialogController from './controllers/user-activation-required-dialog.controller';
import {CatalogueSelectionLoginListener} from './catalogue-selection-login.listener';
import ServerUrlsDataService from './server-urls.data-service';
import CatalogueSelectionModalComponent from './catalogue-selection-modal/catalogue-selection-modal.component';
import LoanSelectionModalComponent from './loan-selection-modal/loan-selection-modal.component';
import SubmittingFormController from './controllers/submitting-form.controller';
import LoanReadyNoticeToSendQuestionController from './controllers/loan-ready-notice-to-send-question.controller';
import PasswordQuestionModalController from './controllers/password-question-modal.controller';
import UserPreferencesModalComponent from './user-preferences-modal/user-preferences-modal.controller';
import SettingsModalComponent from './settings-modal/settings-modal.controller';
import ConfirmationDialogController from './controllers/confirmation-dialog.controller';

/**
 * @ngdoc module
 * @module portaro.conversation
 * @name portaro.conversation
 */

export default register('portaro.conversation')
    .controller(DepartmentCreatedDialogController.controllerName, DepartmentCreatedDialogController)
    .controller(GoToResponseController.controllerName, GoToResponseController)
    .controller(ModalLoanRequestFormController.controllerName, ModalLoanRequestFormController)
    .controller(ModalLoginController.controllerName, ModalLoginController)
    .controller(PasswordQuestionModalController.controllerName, PasswordQuestionModalController)
    .controller(PrintPageController.controllerName, PrintPageController)
    .controller(ConfirmationDialogController.controllerName, ConfirmationDialogController)
    .controller(RedirectionResponseController.controllerName, RedirectionResponseController)
    .controller(SubmittingFormController.controllerName, SubmittingFormController)
    .controller(UniversalFormController.controllerName, UniversalFormController)
    .controller(UserActivationRequiredDialogController.controllerName, UserActivationRequiredDialogController)
    .controller(LoanReadyNoticeToSendQuestionController.controllerName, LoanReadyNoticeToSendQuestionController)
    .service(ModalConversationService.serviceName, ModalConversationService)
    .service(CatalogueSelectionLoginListener.serviceName, CatalogueSelectionLoginListener)
    .service(ServerUrlsDataService.serviceName, ServerUrlsDataService)
    .component(SearchSelectionModalComponent.componentName, SearchSelectionModalComponent)
    .component(RecordEditationModalComponent.componentName, RecordEditationModalComponent)
    .component(RegistrationOptionsModalComponent.componentName, RegistrationOptionsModalComponent)
    .component(CatalogueSelectionModalComponent.componentName, CatalogueSelectionModalComponent)
    .component(LoanSelectionModalComponent.componentName, LoanSelectionModalComponent)
    .component(UserPreferencesModalComponent.componentName, UserPreferencesModalComponent)
    .component(SettingsModalComponent.componentName, SettingsModalComponent)
    .name();
